import { PageLayout } from '@/global/components';
import { Loadable } from '@/components/loaders';
import { Button } from '@/lib';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PerformanceAudienceFilters, PerformanceAudiencePageHeader } from './components';
import { usePerformanceAudienceBootstrap } from './hooks/usePerformanceAudienceBootstrap';
import { PerformanceDashboardContainer } from './PerformanceDashboardContainer';
import ErrorBoundary from '@/components/ErrorBoundary';

export const PerformanceAudiencePage: FC = () => {
  const { t } = useTranslation('performanceAudience');

  const { filters, filterOptions, setAudienceFilter, setGoogleScopeFilter, setMetaScopeFilter, setDateRangeFilter, isInitialLoading, isFiltersReady, isError, refetch } =
    usePerformanceAudienceBootstrap();

  const handleExport = useCallback(() => {
    // Placeholder for dashboard export
  }, []);

  return (
    <ErrorBoundary>
      <PageLayout className='gap-6'>
        <PerformanceAudiencePageHeader onExport={handleExport} />
        <ErrorBoundary>
          {isError ? (
            <div className='rounded-lg border border-red-200 bg-red-50 p-6 text-sm text-red-800'>
              <p>{t('errors.loadFailed')}</p>
              <Button intent='secondary' size='sm' className='mt-4' onClick={() => refetch()}>
                {t('errors.retry')}
              </Button>
            </div>
          ) : (
            <Loadable isLoading={isInitialLoading}>
              <div className='grid gap-5'>
                <PerformanceAudienceFilters
                  audiences={filterOptions.audiences}
                  googleScopes={filterOptions.googleScopes}
                  metaScopes={filterOptions.metaScopes}
                  dateRanges={filterOptions.dateRanges}
                  selectedAudienceId={filters.audienceId}
                  selectedGoogleScopeId={filters.googleScopeId}
                  selectedMetaScopeId={filters.metaScopeId}
                  selectedDateRangeId={filters.dateRange}
                  onAudienceChange={setAudienceFilter}
                  onGoogleScopeChange={setGoogleScopeFilter}
                  onMetaScopeChange={setMetaScopeFilter}
                  onDateRangeChange={setDateRangeFilter}
                />
                <ErrorBoundary>
                  <PerformanceDashboardContainer filters={filters} enabled={isFiltersReady} />
                </ErrorBoundary>
              </div>
            </Loadable>
          )}
        </ErrorBoundary>
      </PageLayout>
    </ErrorBoundary>
  );
};
